import React, { forwardRef } from 'react';
import { Button } from '@10d/tend-ui/primitives/Button';
import { ButtonRef } from '@10d/tend-ui/primitives/Button/types';
import { TTendUIButtonProps } from './types';

const Component = <E extends React.ElementType = 'button'>(
  props: TTendUIButtonProps<E>,
  ref: ButtonRef<E>,
) => {
  return <Button {...props} ref={ref} />;
};

const TendUIButton = forwardRef(Component) as <E extends React.ElementType = 'button'>(
  props: TTendUIButtonProps<E>,
) => JSX.Element;

export default TendUIButton;
